var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPattern(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 284,
    height: 192,
    viewBox: "0 0 284 192",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    d: "M244.736 145.839L243.941 144.567",
    stroke: "#5458F7",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M244.643 152.272L244.616 151.842C244.591 151.474 244.771 151.123 245.083 150.928L249.158 148.382C249.47 148.187 249.864 148.179 250.184 148.361L250.559 148.574C250.963 148.805 251.155 149.285 251.021 149.73L250.023 153.053C249.879 153.534 249.4 153.833 248.904 153.753L245.48 153.193C245.021 153.119 244.674 152.737 244.643 152.272V152.272Z",
    stroke: "#5458F7",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.149 144.779L251.467 143.401",
    stroke: "#5458F7",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.972 151.138L239.594 150.82",
    stroke: "#5458F7",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.815 153.412C245.603 155.315 245.66 157.903 247.359 159.781C248.757 161.326 251.026 161.899 252.982 161.18C256.239 159.984 257.411 156.219 255.678 153.445C254.57 151.672 252.578 150.806 250.63 151.027",
    stroke: "#5458F7",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M203.645 183.896C204.363 183.448 205.239 183.779 205.607 184.367C206.353 185.561 204.965 187.788 204.929 187.811C204.892 187.834 202.283 188.105 201.536 186.911C201.169 186.322 201.256 185.389 201.973 184.941C202.383 184.685 202.773 184.708 203.036 184.782C203.085 184.513 203.235 184.153 203.645 183.896Z",
    stroke: "#5458F7",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.749 182.723L203.037 184.783",
    stroke: "#5458F7",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M206.517 190.352C202.135 193.091 196.453 192.02 193.343 188.035C193.005 187.602 193.07 186.977 193.497 186.633C196.075 184.549 196.784 181.089 194.884 177.463C194.646 177.009 194.816 176.445 195.252 176.175L196.985 175.099L198.712 174.012C199.147 173.738 199.728 173.833 200.032 174.247C202.457 177.543 205.878 178.422 208.88 177.02C209.379 176.788 209.969 177.003 210.21 177.498C212.428 182.039 210.898 187.615 206.517 190.352Z",
    stroke: "#5458F7",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.64 177.5C204.52 179.644 203.546 181.6 201.749 182.723",
    stroke: "#5458F7",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.788 183.031C197.768 183.863 199.953 183.845 201.749 182.723",
    stroke: "#5458F7",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.483 68.8206L260.647 69.9094",
    stroke: "#5458F7",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.523 81.9098L274.627 82.9412",
    stroke: "#5458F7",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.969 73.5522L258.526 73.9117",
    stroke: "#5458F7",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.668 77.8692L277.142 78.2096",
    stroke: "#5458F7",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.155 78.9074L258.678 78.439",
    stroke: "#5458F7",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.511 73.2974L276.956 72.8545",
    stroke: "#5458F7",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.995 83.4529L261.084 82.2891",
    stroke: "#5458F7",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.084 69.4134L274.116 68.309",
    stroke: "#5458F7",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.727 85.9677L265.086 84.4106",
    stroke: "#5458F7",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.044 67.2686L269.384 65.7942",
    stroke: "#5458F7",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.082 85.7816L269.613 84.2583",
    stroke: "#5458F7",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.472 67.4251L264.029 65.9803",
    stroke: "#5458F7",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M265.37 73.1833C265.468 72.5275 265.8 71.6536 266.762 71.0526C268.445 70.0013 270.56 70.875 271.479 72.3464C273.4 75.4205 271.044 80.1685 270.102 80.7572C269.16 81.346 263.86 81.3821 261.939 78.308C261.02 76.8366 261.162 74.5522 262.844 73.5009C263.806 72.8999 264.738 72.9851 265.37 73.1833Z",
    stroke: "#5458F7",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.966 108.42L225.986 107.039",
    stroke: "#5458F7",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.986 97.4433C224.291 98.4372 226.975 102.733 225.982 107.038C224.988 111.343 220.692 114.027 216.387 113.033C212.082 112.039 209.398 107.744 210.392 103.439C211.386 99.1336 215.681 96.4494 219.986 97.4433",
    stroke: "#5458F7",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M217.972 101.966C219.101 101.26 220.517 101.839 221.13 102.82C222.374 104.81 220.246 108.406 220.189 108.442C220.131 108.478 215.966 108.814 214.722 106.824C214.11 105.844 214.21 104.317 215.339 103.611C215.986 103.207 216.609 103.262 217.033 103.393C217.101 102.955 217.326 102.37 217.972 101.966V101.966Z",
    stroke: "#5458F7",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M178.293 128.201C176.732 125.703 173.379 124.983 170.803 126.593C168.226 128.203 167.404 131.532 168.964 134.03C169.612 135.065 170.895 135.43 171.832 134.844C172.769 134.259 173.003 132.945 172.357 131.91C170.796 129.413 167.443 128.692 164.866 130.302C162.29 131.912 161.468 135.242 163.028 137.739C166.229 142.862 174.805 142.958 176.313 142.016C177.821 141.074 181.494 133.323 178.293 128.201Z",
    stroke: "#5458F7",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M125.846 172.456L124.03 173.591C123.093 174.177 121.859 173.892 121.274 172.955L120.577 171.841C120.297 171.391 119.848 171.071 119.331 170.952L118.051 170.656C116.975 170.408 116.304 169.334 116.552 168.258L116.848 166.978C116.967 166.461 116.877 165.918 116.596 165.468L115.899 164.354C115.314 163.417 115.599 162.184 116.536 161.598L117.65 160.902C118.099 160.621 118.419 160.172 118.539 159.655L118.834 158.375C119.083 157.299 120.156 156.628 121.232 156.877L122.513 157.172C123.029 157.292 123.573 157.201 124.022 156.92L125.137 156.224C126.074 155.638 127.307 155.923 127.892 156.86L128.589 157.974C128.87 158.424 129.318 158.743 129.835 158.863L131.115 159.158C132.191 159.407 132.862 160.48 132.614 161.557L132.318 162.837C132.199 163.353 132.29 163.897 132.571 164.346L133.267 165.461C133.852 166.398 133.568 167.631 132.631 168.217L131.516 168.913C131.067 169.194 130.747 169.643 130.628 170.159L130.332 171.439C130.084 172.516 129.01 173.186 127.934 172.938L125.846 172.456Z",
    stroke: "#5458F7",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M124.371 161.468C125.568 160.72 127.067 161.334 127.716 162.372C129.033 164.48 126.779 168.287 126.719 168.325C126.658 168.363 122.248 168.719 120.931 166.612C120.283 165.573 120.388 163.957 121.585 163.209C122.269 162.782 122.93 162.839 123.378 162.979C123.449 162.515 123.687 161.896 124.371 161.468V161.468Z",
    stroke: "#5458F7",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M73.7598 189.249C73.917 188.201 74.4483 186.802 75.9875 185.84C78.6801 184.157 82.0647 185.556 83.5353 187.91C86.6093 192.829 82.8397 200.425 81.3318 201.367C79.824 202.309 71.3445 202.368 68.2704 197.448C66.7999 195.095 67.0262 191.44 69.7187 189.757C71.258 188.795 72.7484 188.931 73.7598 189.249Z",
    stroke: "#5458F7",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.5988 192.792C77.0024 192.885 77.254 193.288 77.1609 193.692C77.0677 194.095 76.665 194.347 76.2614 194.254C75.8578 194.16 75.6061 193.758 75.6993 193.354C75.7925 192.951 76.1952 192.699 76.5988 192.792",
    stroke: "#5458F7",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M294.728 3.16767L284.551 9.5267C283.152 10.4011 281.292 9.97159 280.418 8.57231L274.059 -1.60426C273.184 -3.00354 273.614 -4.8638 275.013 -5.73816L285.189 -12.0972C286.589 -12.9716 288.449 -12.5421 289.323 -11.1428L295.682 -0.966233C296.557 0.433046 296.127 2.2933 294.728 3.16767Z",
    stroke: "#5458F7",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.478 -1.91503C283.232 -3.90964 283.607 -6.39137 285.315 -7.45863C286.05 -7.91807 287.018 -7.69443 287.478 -6.95917C288.482 -5.35297 287.314 -2.81194 284.87 -1.28472C282.426 0.242511 279.63 0.179179 278.626 -1.42787C278.167 -2.16313 278.39 -3.13184 279.126 -3.59181C280.834 -4.65907 283.229 -3.90805 284.476 -1.91344",
    stroke: "#5458F7",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.521 4.10279C285.393 2.93273 285.804 0.211755 284.437 -1.97451L284.448 -1.96476C285.814 0.221508 288.44 1.04537 290.312 -0.124689",
    stroke: "#5458F7",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.101 -8.91767L289.64 6.34719",
    stroke: "#5458F7",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.503 -6.05453L277.238 3.48402",
    stroke: "#5458F7",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.162 33.0093C244.93 32.6 243.744 32.7515 242.823 33.3269C243.744 32.7515 244.4 31.7519 244.572 30.4651",
    stroke: "#5458F7",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.768 32.7863L240.983 37.9306L244.375 35.8109L241.16 30.6658",
    stroke: "#5458F7",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.822 33.3261L239.43 35.4458",
    stroke: "#5458F7",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.872 23.1386C242.962 22.9467 243.038 22.745 243.088 22.5301L243.741 19.6989C242.575 19.4297 241.409 19.7028 240.511 20.3539C239.988 19.3753 239.061 18.6185 237.895 18.3494L237.242 21.1797C236.93 22.5279 237.587 23.8625 238.75 24.4873",
    stroke: "#5458F7",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M243.995 24.6526L241.525 30.1202C241.363 30.4803 241.097 30.7841 240.762 30.9934L238.235 32.5725C237.9 32.7818 237.511 32.8872 237.116 32.8753L231.119 32.6983C230.523 32.6805 230.086 32.1498 230.154 31.5566C230.297 30.2936 230.992 29.1035 232.156 28.3765C232.511 28.1544 232.902 28.0089 233.292 27.9009C233.506 26.7412 234.187 25.6734 235.261 25.002C236.336 24.3305 237.594 24.187 238.739 24.4972C239.007 24.1941 239.3 23.9119 239.665 23.6841C240.821 22.9618 242.194 22.8594 243.393 23.2835C243.955 23.4835 244.241 24.109 243.995 24.6526V24.6526Z",
    stroke: "#5458F7",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.997 24.3817C237.329 23.5294 237.278 22.5401 236.756 21.7048L235.217 19.2412C234.202 19.8755 233.572 20.8919 233.396 21.9885C232.334 21.6664 231.144 21.7864 230.129 22.4207L231.668 24.8843C232.187 25.7145 233.047 26.1925 233.953 26.2725",
    stroke: "#5458F7",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.252 31.0248C230.04 31.0216 229.825 31.0012 229.61 30.9515L226.78 30.2972C227.049 29.1315 227.805 28.2037 228.784 27.6816C228.134 26.7825 227.86 25.6177 228.129 24.4519L230.959 25.1053C232.308 25.4159 233.219 26.5916 233.271 27.9105",
    stroke: "#5458F7",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.038 55.2703L194.659 56.2642C196.122 58.6056 195.41 61.6909 193.069 63.154V63.154C190.727 64.6171 187.642 63.9048 186.179 61.5634L185.247 60.0717",
    stroke: "#5458F7",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.069 63.154L194.658 65.6982",
    stroke: "#5458F7",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.102 50.8578V50.8578C191.507 49.9797 193.358 50.4069 194.236 51.8121V51.8121C195.114 53.2174 194.686 55.068 193.281 55.9461L187.853 59.3381L187.769 59.3905C185.662 60.7074 182.885 60.0663 181.568 57.9589V57.9589C180.251 55.8515 180.892 53.0749 183 51.7581L183.084 51.7056L185.968 49.9034C187.373 49.0253 189.224 49.4525 190.102 50.8578V50.8578C190.98 52.263 190.553 54.1136 189.147 54.9917L186.695 56.5242L186.669 56.5401C185.967 56.9789 185.041 56.7651 184.602 56.0629V56.0629C184.164 55.3607 184.377 54.4347 185.08 53.9959L185.105 53.98L186.801 52.9202",
    stroke: "#5458F7",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M153.305 90.3594L139.97 98.6918C138.969 99.3176 137.65 99.0132 137.024 98.0117L130.812 88.0691C130.186 87.0676 130.49 85.7489 131.492 85.123L144.826 76.7906C145.828 76.1648 147.147 76.4692 147.773 77.4708L153.985 87.4133C154.611 88.4148 154.307 89.7335 153.305 90.3594Z",
    stroke: "#5458F7",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M142.235 84.3057C141.882 84.5275 141.624 84.8576 141.489 85.2343C141.352 85.6171 140.948 85.8693 140.544 85.8246C140.146 85.7807 139.735 85.8679 139.38 86.09C138.527 86.6225 138.367 87.9042 138.901 88.7581C140.067 90.6247 143.592 90.5328 143.988 90.2853C144.384 90.0379 146.012 86.91 144.846 85.0434C144.312 84.1894 143.089 83.7721 142.235 84.3057V84.3057Z",
    stroke: "#5458F7",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.315 88.62L145.238 87.0398",
    stroke: "#5458F7",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.575 90.0126L138.113 98.8856",
    stroke: "#5458F7",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.132 76.8237L144.345 84.4967",
    stroke: "#5458F7",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.614 87.9126L130.504 87.1433",
    stroke: "#5458F7",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.4788 116.85L86.5153 120.36C86.3449 120.982 86.7981 121.6 87.442 121.624L96.4255 121.957C97.2437 121.987 97.9985 121.516 98.3302 120.767L101.965 112.554C102.227 111.962 101.867 111.281 101.23 111.166L97.6744 110.522",
    stroke: "#5458F7",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.6129 121.126L91.5014 128.949C91.8013 129.429 92.4245 129.581 92.8926 129.288L106.461 120.81C106.929 120.517 107.066 119.891 106.766 119.411L101.878 111.587",
    stroke: "#5458F7",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.14 129.405L93.8802 121.867",
    stroke: "#5458F7",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.3585 118.444L106.896 120.184",
    stroke: "#5458F7",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.673 115.321L95.7566 107.453C95.4641 106.985 94.8468 106.842 94.3786 107.135L85.8982 112.434C85.43 112.726 85.2875 113.344 85.58 113.812L90.4966 121.68",
    stroke: "#5458F7",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M93.3029 112.524C94.2001 111.963 95.2956 112.376 95.755 113.111C96.6882 114.605 94.9535 117.388 94.9077 117.417C94.8619 117.445 91.5999 117.784 90.6667 116.291C90.2073 115.556 90.316 114.39 91.2133 113.829C91.7263 113.509 92.213 113.538 92.5416 113.63C92.6031 113.295 92.7898 112.844 93.3029 112.524Z",
    stroke: "#5458F7",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.8633 143.699L47.736 136.28C48.6731 135.695 49.9064 135.979 50.4919 136.916L57.3809 147.941",
    stroke: "#5458F7",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.794 156.844V156.844C49.7311 156.259 50.0159 155.025 49.4303 154.088L48.9004 153.24",
    stroke: "#5458F7",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.4516 141.8C47.169 141.351 48.0455 141.682 48.4133 142.271C49.1594 143.465 47.7716 145.691 47.7351 145.714",
    stroke: "#5458F7",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.7793 142.845C44.0618 143.293 43.9749 144.226 44.3427 144.814C45.0888 146.008 47.6987 145.737 47.7351 145.714",
    stroke: "#5458F7",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.8422 142.685C45.8912 142.416 46.0412 142.056 46.4516 141.8",
    stroke: "#5458F7",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.8422 142.685C45.5792 142.611 45.1897 142.588 44.7793 142.845",
    stroke: "#5458F7",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.7807 149.848L52.717 146.139",
    stroke: "#5458F7",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.9004 153.24L59.077 146.881L59.5513 147.64C60.1676 148.627 59.8679 149.925 58.8816 150.541V150.541L48.7941 156.844C47.857 157.43 46.6237 157.145 46.0381 156.208L39.1492 145.183L38.6193 144.335C38.0337 143.398 36.8004 143.114 35.8633 143.699V143.699C34.9262 144.285 34.6415 145.518 35.2271 146.455L35.757 147.303",
    stroke: "#5458F7",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.757 147.303L39.1492 145.183",
    stroke: "#5458F7",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-9.50771 176.767L2.36496 169.348C3.30205 168.762 4.53533 169.047 5.1209 169.984L10.95 179.313C11.5356 180.25 11.2508 181.483 10.3137 182.069L0.137174 188.428C-0.79992 189.013 -2.0332 188.728 -2.61876 187.791L-9.48069 176.81C-9.9486 176.061 -9.86986 175.095 -9.28786 174.431L-2.20165 166.357C-1.76001 165.853 -0.957281 165.918 -0.602235 166.486L1.51691 169.878",
    stroke: "#5458F7",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.859218 175.005C2.11518 174.221 3.64915 174.8 4.29247 175.829C5.59819 177.919 3.16937 181.816 3.10577 181.856C3.04217 181.896 -1.52541 182.37 -2.83113 180.281C-3.47445 179.251 -3.32251 177.619 -2.06655 176.834C-1.34825 176.385 -0.666888 176.426 -0.207285 176.554C-0.120745 176.085 0.140922 175.454 0.859218 175.005Z",
    stroke: "#5458F7",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M168.984 11.157V11.157C170.095 9.7359 169.686 7.65806 168.119 6.76497L163.49 4.12588C163.059 3.87981 162.513 3.98746 162.207 4.37825L160.703 6.29978C160.393 6.69683 160.427 7.26276 160.781 7.62033L164.554 11.4195C165.809 12.6819 167.886 12.5584 168.984 11.157Z",
    stroke: "#5458F7",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.812 11.8652L170.605 14.6941",
    stroke: "#5458F7",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.818 9.66685L167.771 6.57212",
    stroke: "#5458F7",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.984 11.1557L171.707 13.2865",
    stroke: "#5458F7",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M156.892 18.7126V18.7126C155.127 19.089 153.439 17.8103 153.324 16.0099L152.981 10.6926C152.949 10.1975 153.285 9.75405 153.77 9.6499L156.156 9.14121C156.649 9.0359 157.143 9.31462 157.309 9.78983L159.07 14.846C159.654 16.528 158.633 18.3409 156.892 18.7126Z",
    stroke: "#5458F7",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.851 22.4636L159.36 21.7208",
    stroke: "#5458F7",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.256 12.5178L153.295 15.6178",
    stroke: "#5458F7",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.891 18.7123L157.612 22.0938",
    stroke: "#5458F7",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.048 3.04895L159.366 1.67098",
    stroke: "#5458F7",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.96 6.22844L152.582 5.91031",
    stroke: "#5458F7",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.974 3.79064L155.444 2.94259",
    stroke: "#5458F7",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M122.023 41.6806V41.6806C123.135 40.2594 122.725 38.1816 121.158 37.2885L116.529 34.6494C116.098 34.4033 115.552 34.511 115.246 34.9018L113.743 36.8233C113.432 37.2204 113.466 37.7863 113.82 38.1439L117.593 41.943C118.849 43.2054 120.926 43.0819 122.023 41.6806Z",
    stroke: "#5458F7",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.851 42.3887L123.645 45.2176",
    stroke: "#5458F7",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.857 40.1904L120.81 37.0957",
    stroke: "#5458F7",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.023 41.6792L124.746 43.8101",
    stroke: "#5458F7",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M109.931 49.2362V49.2362C108.167 49.6125 106.479 48.3338 106.363 46.5335L106.02 41.2162C105.988 40.721 106.324 40.2776 106.81 40.1734L109.196 39.6647C109.689 39.5594 110.182 39.8381 110.348 40.3134L112.109 45.3695C112.693 47.0516 111.672 48.8644 109.931 49.2362Z",
    stroke: "#5458F7",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.89 52.9871L112.4 52.2443",
    stroke: "#5458F7",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.295 43.0413L106.334 46.1414",
    stroke: "#5458F7",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.93 49.2358L110.652 52.6173",
    stroke: "#5458F7",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.436 31.1373C109.306 30.5941 110.382 31.0191 110.842 31.7543C111.775 33.2477 110.117 35.9827 110.073 36.0103",
    stroke: "#5458F7",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.411 32.4027C105.542 32.9459 105.452 34.1 105.911 34.8353C106.844 36.3287 110.029 36.0378 110.073 36.0103",
    stroke: "#5458F7",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.707 32.2237C107.763 31.8918 107.939 31.4478 108.436 31.1373",
    stroke: "#5458F7",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.707 32.2237C107.385 32.1282 106.908 32.0922 106.411 32.4027",
    stroke: "#5458F7",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.7189 67.9111L59.1111 65.7914",
    stroke: "#5458F7",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M72.9701 70.9867V70.9867C71.151 72.1234 68.7491 71.3744 67.9048 69.408L65.4595 63.7077C65.265 63.2549 65.4313 62.7265 65.8511 62.4642L68.6174 60.7356C69.0482 60.4664 69.612 60.561 69.9286 60.9563L73.8487 65.8353C75.1589 67.4658 74.7476 69.876 72.9701 70.9867Z",
    stroke: "#5458F7",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.6764 73.4234L59.0218 73.4234C60.5515 73.4239 61.9474 72.5516 62.6176 71.1766L63.2074 69.9673",
    stroke: "#5458F7",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55.2687 64.3601L56.1168 63.8302C56.5849 63.5377 57.2022 63.6802 57.4947 64.1483L58.5996 65.9165C59.6107 67.5346 61.042 68.8476 62.7412 69.7138V69.7138C64.4409 70.5808 65.8722 71.8939 66.8828 73.5111L69.0475 76.9754C69.6331 77.9125 69.3483 79.1457 68.4112 79.7313L64.171 82.3809C63.2339 82.9664 62.0006 82.6817 61.4151 81.7446L59.2504 78.2804C58.2393 76.6623 57.6865 74.8002 57.6529 72.8933V72.8933C57.6187 70.9855 57.066 69.1235 56.0555 67.5062L54.9506 65.7381C54.6581 65.2699 54.8006 64.6526 55.2687 64.3601Z",
    stroke: "#5458F7",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M63.4179 74.5973C64.1353 74.149 65.0118 74.4798 65.3796 75.0683C66.1257 76.2624 64.7378 78.4892 64.7014 78.512C64.6649 78.5347 62.0551 78.806 61.3089 77.6119C60.9412 77.0234 61.0281 76.0906 61.7455 75.6423C62.156 75.3858 62.5454 75.4089 62.8085 75.4827C62.8575 75.2139 63.0074 74.8537 63.4179 74.5973V74.5973Z",
    stroke: "#5458F7",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.97 70.9867L75.6196 75.227",
    stroke: "#5458F7",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.9236 76.2868L77.3158 74.1671",
    stroke: "#5458F7",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.8981 63.4023L66.7165 66.6401",
    stroke: "#5458F7",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5338 97.0303C10.7533 97.3816 11.216 97.4884 11.5673 97.2689C11.9186 97.0494 12.0254 96.5867 11.8059 96.2354L10.5338 97.0303ZM9.68621 92.8432C9.46671 92.4919 9.004 92.3851 8.65273 92.6046C8.30146 92.8241 8.19464 93.2868 8.41413 93.6381L9.68621 92.8432ZM17.3182 92.7909C17.5377 93.1422 18.0004 93.249 18.3517 93.0295C18.7029 92.81 18.8098 92.3473 18.5903 91.9961L17.3182 92.7909ZM16.4706 88.6039C16.2511 88.2526 15.7884 88.1458 15.4371 88.3653C15.0858 88.5848 14.979 89.0475 15.1985 89.3987L16.4706 88.6039ZM11.8059 96.2354L9.68621 92.8432L8.41413 93.6381L10.5338 97.0303L11.8059 96.2354ZM18.5903 91.9961L16.4706 88.6039L15.1985 89.3987L17.3182 92.7909L18.5903 91.9961Z",
    fill: "#5458F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.51935 101.827L23.7842 92.288",
    stroke: "#5458F7",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.92959 99.2825L13.8185 110.307C14.4041 111.244 15.6374 111.529 16.5745 110.943L28.4471 103.524C29.3842 102.939 29.669 101.706 29.0834 100.769L22.1945 89.7439C21.6089 88.8068 20.3756 88.5221 19.4385 89.1077L7.56585 96.5265C6.62875 97.1121 6.34403 98.3454 6.92959 99.2825Z",
    stroke: "#5458F7",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.0513 99.3726C19.9486 98.812 21.044 99.2253 21.5035 99.9605C22.4361 101.453 20.7019 104.237 20.6561 104.266",
    stroke: "#5458F7",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9618 100.678C16.0645 101.239 15.9558 102.405 16.4152 103.14C17.3479 104.633 20.6103 104.294 20.6561 104.266",
    stroke: "#5458F7",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.29 100.479C18.3515 100.144 18.5382 99.6932 19.0513 99.3726",
    stroke: "#5458F7",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.29 100.479C17.9614 100.387 17.4748 100.358 16.9617 100.678",
    stroke: "#5458F7",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPattern);
export default __webpack_public_path__ + "static/media/pattern.169b3051.svg";
export { ForwardRef as ReactComponent };